import { ContextRouter, LocationShape, Route } from 'react-router-dom'
import type { ReactNode, ComponentType } from 'react'
import React from 'react'
import { NotFound } from '../../not-found'
import type { RootState } from 'shared/store/reducers'
import { useSelector } from 'react-redux'

type FeatureToggledRouteProps = {
    component?: ComponentType,
    render?: (router: ContextRouter) => ReactNode,
    children?: ComponentType<ContextRouter> | ReactNode,
    path?: string | Array<string>,
    exact?: boolean,
    strict?: boolean,
    location?: LocationShape,
    sensitive?: boolean
} & { feature: string }
export const FeatureToggledRoute = ({
    feature,
    component,
    ...props
}: FeatureToggledRouteProps) => {
    const { availableFeatures } = useSelector((state: RootState) => {
        const { available: availableFeatures } = state.featuresState

        return {
            availableFeatures
        }
    })

    const loaded = !!availableFeatures && availableFeatures.length
    const Component =
        availableFeatures && availableFeatures.includes(feature)
            ? component
            : NotFound

    return <Route {...props} component={loaded ? Component : null} />
}
